import React, { useState, useEffect } from "react";
import { Flex, Text, Image } from "@chakra-ui/react";
import { Reorder } from "framer-motion";
import { textPrimary, textSecondary } from "../../utils/colors";
import { useTranslation } from "react-i18next";
import noServices from "../../assets/images/empty-box.png";
import ServiceItemNew from "./ServiceItemNew";

const ServiceListNew = ({
  services,
  updateServiceOrder,
  saveEditedService,
  removeService,
  isEdit,
  tpStatus,
  setStatus,
  oneLeftToComplete,
  oneLeftToUncomplete,
  resetServicesStatusToUncompleted,
  currency,
}) => {
  const { t } = useTranslation();
  const [currentServices, setCurrentServices] = useState(services);

  useEffect(() => {
    setCurrentServices(services);
  }, [services]);

  const handleReorder = (newOrder) => {
    if (tpStatus !== "cancelled") {
      // Reorder and update sortOrder
      const updatedServices = newOrder.map((service, index) => ({
        ...service,
        order: index + 1,
      }));

      // Update the state and pass it back up to the parent
      setCurrentServices(updatedServices);
      updateServiceOrder(updatedServices); // Notify parent of the updated services list
    } else {
      console.log("Cannot reorder while cancelled");
    }
  };

  // console.log("tpStatus", tpStatus);
  // console.log("isEdit", isEdit);
  // console.log('services', services);
  // console.log("currency", currency);

  return (
    <>
      <Flex direction="column">
        {services && services.length > 0 ? (
          <Reorder.Group
            axis="y"
            onReorder={handleReorder} // Correct reordering for services
            values={currentServices}
            style={{ listStyleType: "none" }}
          >
            {currentServices.map((service, index) => (
              <ServiceItemNew
                key={service._id}
                service={service}
                index={index}
                saveEditedService={saveEditedService}
                removeService={removeService}
                isEdit={isEdit}
                tpStatus={tpStatus}
                setStatus={setStatus}
                oneLeftToComplete={oneLeftToComplete}
                oneLeftToUncomplete={oneLeftToUncomplete}
                resetServicesStatusToUncompleted={
                  resetServicesStatusToUncompleted
                }
                currency={currency}
              />
            ))}
          </Reorder.Group>
        ) : (
          <Flex w="100%" align="center" justify="center" p="3rem 0 3rem">
            <Flex align="center" justify="center" direction="column">
              <Image h="3rem" w="auto" m="0rem 0 1rem" src={noServices} />
              <Text fontSize="1rem" fontWeight="600" color={textPrimary}>
                {t("service.noServicesTitle")}
              </Text>
              <Text
                fontSize="sm"
                fontWeight="500"
                color={textSecondary}
                m="0rem auto 1rem"
                maxW="300px"
                textAlign="center"
              >
                {t("service.noServicesText")}
              </Text>
            </Flex>
          </Flex>
        )}
      </Flex>
    </>
  );
};

export default ServiceListNew;
